import api from '@/common/api';
import apiAI from '@/common/api-ai';
// import Vue from 'vue';
/* eslint-disable */

// const defTags = [
//     { title: "Сравнить с должностным профилем", },
//     { title: "Оценить навыки коммуникации", },
//     { title: "Проанализировать тревожность", },
//     { title: "Проанализировать все", }
// ]
// const defPromptsUser = [
//         { id: 1, content: 'Проанализируй резюме кандидата и выдели ключевые навыки, соответствующие вакансии. ' },
//         { id: 2, content: 'Проанализируй резюме кандидата и выдели еще что-нибудь.' },
// ]
// const defPromptsStd = [
//         { id: 1, title: 'Эмоциональное состояние кандидата', content: 'Ты - требовательный HR специалист.\r\nДействие:  внимательно изучить транскрипт записи собеседования и провести тональный анализ речи кандидата' },
//         { id: 2, title: 'Сравнение опыта работы кандидата с требованиями вакансии и оценка релевантности.', content: 'Ты - требовательный HR специалист.\r\nДействие:  внимательно изучить транскрипт записи собеседования и провести тональный анализ речи кандидата' },
// ]

const initialState = () => ({
  tags: [],
  promptsUser: [],
  promptsStd: [],
  selectedPromptStdId: 0,
  selectedPromptUserId: 0,
  systemPrompt: '',
  loading: {
    load: false,
    loadItem: 0,
    delPromptUser: false,
    savePromptUser: false,
    loadSystemPrompt: false,
    saveSystemPrompt: false,
  },
  errors: {
    load: [],
    loadItem: [],
    delPromptUser: [],
    savePromptUser: [],
  },
});

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))


export default {
  namespaced: true,
  state: initialState,
  getters: {
    loading: (state) => state.loading,
    tags: (state) => state.tags,
    promptsUser: (state) => state.promptsUser,
    promptsStd: (state) => state.promptsStd,
    selectedPromptStdId: (state) => state.selectedPromptStdId,
    selectedPromptUserId: (state) => state.selectedPromptUserId,

    getSelectedPromptStd: (state) => state.promptsStd.find(el => el.id === state.selectedPromptStdId),
    getSelectedPromptUser: (state) => state.promptsUser.find(el => el.id === state.selectedPromptUserId),
    userId: (state, getters, rootState, rootGetters) => {
      const user = rootGetters['auth/user']
      return user.user.toString()
    },
  },
  mutations: {
    startLoading(state, field) {
      state.loading[field] = true;
    },
    startLoadingId(state, { field, id }) {
      state.loading[field] = id;
    },
    endLoading(state, field) {
      state.loading[field] = false;
    },
    clearError(state) {
      state.errors = initialState().errors;
    },
    setError(state, {type, errors}) {
      state.errors[type] = errors;
    },

    addPromptUser(state, item) {
      state.promptsUser.push(item)
    },
    delPromptUser(state, id) {
      const ind = state.promptsUser.findIndex(el => el.id === id)
      if (ind>=0) {
        state.promptsUser.splice(ind, 1);
        state.selectedPromptUserId = 0
      }
    },
    editPromptUser(state, { id, content, title }) {
      const p = state.promptsUser.find(el => el.id === id)
      if (p) {
        p.content = content
        p.title = title
      }
    },

    setPromptsUser(state, items) {
      state.promptsUser = items
    },
    setPromptsStd(state, items) {
      state.promptsStd = items
    },
    setTags(state, items) {
      state.tags = items
    },
    setSelectedPromptUserId(state, id) {
      state.selectedPromptUserId = id
    },
    setSelectedPromptStdId(state, id) {
      state.selectedPromptStdId = id
    },
    setSystemPrompt(state, prompt) {
      state.systemPrompt = prompt
    },

  },
  actions: {
    async loadPrompts({ commit, state, getters, rootGetters }) {
      commit('startLoading', 'load');

      try {
        const std = await api.get(`/ai-expert/default-prompts/`, { timeout: 0 })
        commit('setPromptsStd', std);

        const tags = await api.get(`/ai-expert/default-prompts/shortcuts/`, { timeout: 0 })
        commit('setTags', tags);

        const userPs = await api.get(`/ai-expert/custom-prompts/`, { timeout: 0 })
        commit('setPromptsUser', userPs);
      } catch (err) {
          console.log(err);
          commit('setError', { type: 'load', errors: err.data });
      } finally {
        commit('endLoading', 'load');
      }
    },

    async loadPromptStd({ commit, state, getters, rootGetters }, id) {
      commit('startLoading', 'loadItem');
      try {
        const response = await api.get(`/ai-expert/default-prompts/${id}/`, { timeout: 0 })
        return response
      } catch (err) {
          console.log(err);
          commit('setError', { type: 'loadItem', errors: err.data });
      } finally {
        commit('endLoading', 'loadItem');
      }
    },

    async loadPromptUser({ commit, state, getters, rootGetters }, id) {
      commit('startLoading', 'loadItem');
      try {
        const response = await api.get(`/ai-expert/custom-prompts/${id}/`, { timeout: 0 })
        return response
      } catch (err) {
          console.log(err);
          commit('setError', { type: 'loadItem', errors: err.data });
      } finally {
        commit('endLoading', 'loadItem');
      }
    },

    async delPromptUser({ commit, state, getters, rootGetters }, id) {
        commit('startLoading', 'delPromptUser' );
        try {
          const response = await api.delete(`/ai-expert/custom-prompts/${id}/`, { timeout: 0 })
          console.log(response)
          commit('delPromptUser', id);
        } catch (err) {
          console.log(err);
          commit('setError', { type: 'delPromptUser', errors: err.data });
        } finally {
          commit('endLoading', 'delPromptUser');
        }
    },

    async editPromptUser({ commit, state, getters, rootGetters }, payload) {
      commit('startLoading', 'savePromptUser' );
      try {
        if (state.selectedPromptUserId) {
          const prompt = { id: state.selectedPromptUserId, content: payload.content, title: payload.title }
          const response = await api.patch(`/ai-expert/custom-prompts/${prompt.id}/`, prompt, { timeout: 0 })
          console.log(response)
          commit('editPromptUser', prompt );
          return true
        } else {
          const response = await api.post(`/ai-expert/custom-prompts/`, { content: payload.content, title: payload.title }, { timeout: 0 })

          commit('addPromptUser', response);
          return true
        }
      } catch (err) {
        console.log(err);
        commit('setError', { type: 'savePromptUser', errors: err.data });
      } finally {
        commit('endLoading', 'savePromptUser');
      }
    },

    async loadSystemPrompt({ commit, dispatch, state, getters, rootGetters }) {
      commit('startLoading', 'loadSystemPrompt');

      try {
        const response = await apiAI.get(`/system-prompt/${getters.userId}`, )
        commit('setSystemPrompt', response?.system_prompt	);
        return response.system_prompt ? response.system_prompt : ''

      } catch (err) {
          console.log(err);
          commit('setError', { type: 'loadSystemPrompt', errors: err.data });
      } finally {
        commit('endLoading', 'loadSystemPrompt');
      }
    },

    async saveSystemPrompt({ commit, dispatch, state, getters, rootGetters }, system_prompt) {
      commit('startLoading', 'saveSystemPrompt');

      try {
        const response = await apiAI.put(`/system-prompt/${getters.userId}`, {system_prompt} )
        return response
      } catch (err) {
          console.log(err);
          commit('setError', { type: 'saveSystemPrompt', errors: err.data });
      } finally {
        commit('endLoading', 'saveSystemPrompt');
      }
    },


  },

};
